
import { Options, Vue } from 'vue-class-component';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import { Prop, Watch } from 'vue-property-decorator';
import { $api } from '@/services';
import { _ROUTER_NAME } from '@/enums';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { isLitePackage } from '@/helper/packageTier';
import { useStore } from 'vuex';

@Options({
	name: 'Authorization',
	components: { SwitchButton },
})
export default class Authorization extends Vue {
	store = useStore();
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() org!: any;

	//----------------------- 🤍 Data 🤍 -----------------------//
	enable_show_dob_of_student_for_staff = false;
	enable_staff_access_all_student_plans = false;
	onChange = false;
	onWatchOrg = true;
	teachers = [];
	enable_assessment_document_creation_right = false;
	enable_staff_send_attendance_track = false;
	enable_staff_send_day_care_attendance_track = false;
	//----------------------------------------------------------//

	get isLitePackage() {
		return isLitePackage(this.store.state.profile);
	}
	mounted() {
		if (
			!this.isLitePackage &&
			this.enable_assessment_document_creation_right
		)
			this.fetchTeacherInPeriodicAssessment();
	}

	flagCheck() {
		return FLAG_CHECK('DAYCARE_ATTENDANCE');
	}

	addTeachers() {
		this.$router.push({
			name: _ROUTER_NAME.SETUP_PERIODIC_ASSESSMENT_ADD_TEACHER,
		});
	}

	async fetchTeacherInPeriodicAssessment() {
		try {
			const {
				data: { data },
			} = await $api.org.getTeacherPeriodicAssessment();
			this.teachers = data;
		} catch (e) {
			console.log(e);
		}
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('org', { deep: true, immediate: true })
	onOrgChange(org: any) {
		if (org && this.onWatchOrg) {
			this.enable_show_dob_of_student_for_staff =
				org?.enable_show_dob_of_student_for_staff;

			this.enable_staff_access_all_student_plans =
				org?.enable_staff_access_all_student_plans;

			this.enable_assessment_document_creation_right =
				org?.enable_assessment_document_creation_right;

			this.enable_staff_send_attendance_track =
				org?.enable_staff_send_attendance_track;
			this.enable_staff_send_day_care_attendance_track =
				org?.enable_staff_send_day_care_attendance_track;
			setTimeout(() => {
				this.onChange = true;
			}, 1000);
			this.onWatchOrg = false;
		}
	}

	@Watch('enable_staff_access_all_student_plans')
	onChangeStaffAccessAllStudentPlan(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_staff_access_all_student_plans: value,
			});
		}
	}

	@Watch('enable_show_dob_of_student_for_staff')
	onChangeAiButton(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_show_dob_of_student_for_staff: value,
			});
		}
	}

	@Watch('enable_assessment_document_creation_right')
	onEnable_change_creation_right(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_assessment_document_creation_right: value,
			});
		}
	}
	@Watch('enable_staff_send_attendance_track')
	onEnable_staff_send_attendance_track(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_staff_send_attendance_track: value,
			});
		}
	}
	@Watch('enable_staff_send_day_care_attendance_track')
	onEnable_staff_send_day_care_attendance_track(value: any) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_staff_send_day_care_attendance_track: value,
			});
		}
	}
}
